var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "transcript-reason-action" }, [
    _c("div", { staticClass: "transcript-reason-action__item" }, [
      _c(
        "span",
        { staticClass: "transcript-reason-action__dot" },
        [
          _c("icon-svg", {
            attrs: { name: "mdi-target", size: 18, color: "#5B5B5B" }
          })
        ],
        1
      ),
      _c("div", { staticClass: "transcript-reason-action__content" }, [
        _c(
          "p",
          { staticClass: "az-text-primary az-size-12 font-semibold mb-1" },
          [_vm._v("Motivo")]
        ),
        _c("p", { staticClass: "az-text-primary az-size-14 mb-0" }, [
          _vm._v(
            " " + _vm._s(_vm.reason || "Sem justificativa registrada.") + " "
          )
        ])
      ])
    ]),
    _vm.recommendation
      ? _c("div", { staticClass: "transcript-reason-action__item" }, [
          _c(
            "span",
            {
              staticClass:
                "transcript-reason-action__dot transcript-reason-action__dot--action"
            },
            [
              _c("icon-svg", {
                attrs: { name: "lamp-on", size: 16, color: "var(--success)" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "transcript-reason-action__content" }, [
            _c(
              "div",
              {
                staticClass: "transcript-reason-action__action rounded-sm pa-3"
              },
              [
                _c("p", { staticClass: "az-text-primary az-size-14 mb-0" }, [
                  _c(
                    "span",
                    { staticClass: "transcript-reason-action__action-label" },
                    [_vm._v(" Recomendação: ")]
                  ),
                  _vm._v(" " + _vm._s(_vm.recommendation) + " ")
                ])
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }